import React from 'react';
import ComponentIcon from '@material-ui/icons/Add';

export const AddIcon: React.FC<any> = (props) => {
  return <ComponentIcon {...props} />;
};

